import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Logo from '../Logo';

export default function ResetPassword({ onBackToLogin, onBackHome }) {
  const { updatePassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!password) {
      setError('Please enter a new password.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    const { error: updateError } = await updatePassword(password);
    setLoading(false);

    if (updateError) {
      setError(updateError.message);
      return;
    }

    setMessage('Password updated successfully. You can now log in with your new password.');
    setPassword('');
    setConfirmPassword('');
  };

  return (
    <main className="auth-page">
      <div className="auth-shell">
        <section className="auth-visual">
          <button type="button" className="auth-back-link" onClick={onBackHome}>
            Back to home
          </button>
          <div className="auth-brand">
            <div className="auth-brand-mark">
              <Logo width={28} height={28} />
            </div>
            <span>GoHalfsies</span>
          </div>
          <h1>Create a new password.</h1>
          <p>Use a password you have not used before. Then log in on any device.</p>
        </section>

        <section className="auth-form-card">
          <p className="auth-eyebrow">Account recovery</p>
          <h2>Set new password</h2>
          <p className="auth-subhead">Enter your new password to complete recovery.</p>

          {error && <div className="auth-error">{error}</div>}
          {message && <div className="auth-message-card">{message}</div>}

          {!message && (
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label>New password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  placeholder="••••••••"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label>Confirm password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  placeholder="••••••••"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Updating...' : 'Update password'}
              </button>
            </form>
          )}

          <div className="auth-switch-row">
            <span>Done?</span>
            <button type="button" className="auth-switch-btn" onClick={onBackToLogin}>
              Back to login
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
